import triggerAnalyticsEvent, {
  analyticsConfig
} from 'syf-js-utilities/helpers/triggerAnalyticsEvent'
import { analyticsConfig as analyticsConfigV2 } from '@syf-utils/analytics'
import getLanguageFromStorage from './getLanguageFromStorage'

export function setAnalyticsDefaults(
  keyValues: Record<string, string | null | undefined>
) {
  Object.entries(keyValues).forEach(([key, value]) => {
    if (value == null) return
    analyticsConfig.defaults[key] = value
    analyticsConfigV2.defaults[key] = value
  })
}

if (navigator.cookieEnabled) {
  setAnalyticsDefaults({
    Country_Language: `us|${getLanguageFromStorage()}`,
    ClientName: localStorage.getItem('client'),
    Token: sessionStorage.getItem('correlationId')
  })
}

setAnalyticsDefaults({
  CustomerType: 'consumer',
  Product: 'generic',
  PageKind: 'multiaccount',
  pageName: 'view',
  PageFunction: 'dashboard',
  SiteIdentifier: 'vista',
  PNL: 'vista'
})

export default triggerAnalyticsEvent
